import { useTranslation } from "react-i18next";
import { ChangeOrgTextField } from "./ChangeOrgTextField";

interface Props {
  currentValue: string;
}

export const ChangeStreet = ({ currentValue }: Props) => {
  const { t } = useTranslation();

  return (
    <ChangeOrgTextField
      currentValue={currentValue}
      fieldName="street"
      label={t("Street")}
      helperText={t("Please provide your company's street address")}
      toastMessage={t("Street has been updated!")}
      buildPatch={(value) => ({ street: { value } })}
    />
  );
};
